module.exports = "<main class=\"food-prep-time\">\n  <header class=\"food-prep-time__page-header\">\n    <h1>\n      <img\n        ng-src=\"https://media-cdn.grubhub.com/grubhub-assets/image/upload/v1748544546/wonderful/grubhub/GrubhubMerchants_Horizontal_Color.svg\"\n        alt=\"Grubhub For Restaurants.\"\n        class=\"food-prep-time__page-header-image\"\n      />\n    </h1>\n  </header>\n\n  <div class=\"cb-modal-backdrop\">\n    <div class=\"cb-modal\">\n      <food-prep-time-stepper ctrl=\"$ctrl\"></food-prep-time-stepper>\n    </div>\n  </div>\n</main>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/foodPrepTime/foodPrepTime.html
// module id = 795
// module chunks = 0